import CDad from "pages/c-dad";
import HeadersPageRevised from "pages/cdad-header-revised";
import UserData from "pages/c-dad-user-data";
import Home from "pages/home";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginErrorPage from "pages/login/LoginError";
import LoginPage from "pages/login/Login";
import Canva from "pages/canva";

const AllRoutes = () => {
  const isAuthenticated = sessionStorage.getItem('userInfo');
  return (
    <Routes>
      <Route path="/home" element={isAuthenticated ? <Home /> : <Navigate to="/" replace />} />
      <Route path="/headers-data" element={isAuthenticated ? <HeadersPageRevised /> : <Navigate to="/" replace />} />
      <Route path="/c-dad" element={isAuthenticated ? <CDad /> : <Navigate to="/" replace />} />
      <Route path="/raw-data" element={isAuthenticated ? <UserData /> : <Navigate to="/" replace />} />
      <Route path="/canva" element={isAuthenticated ? <Canva /> : <Navigate to="/" replace />} />
      <Route path="/" element={<LoginPage />} />
      <Route path="/login-error" element={<LoginErrorPage />} />
    </Routes>
  );
};

export default AllRoutes;
